import React, { useEffect, useState, useRef } from 'react'
import { Button, Col, Row, Input, notification, Drawer, Select } from 'antd'
import { filterOption, InputBox, Intakes } from '../../../components/_utils/appUtils'
import { useDispatch } from 'react-redux'
import { addAssessmentActivityFxn } from '../action/index'
import { listQuickSearchUniversities } from '../../university/actions/university'

const { Option } = Select
const initialFields = {
  universityId: undefined,
  courseName: '',
  campus: '',
  intake: '',
  fees: '',
  initialDeposit: '',
  scholarship: '',
  casDeposit: '',
  initialForInterview: ''
}
const AddAssessment = (props) => {
  let { visible, onClose, assessmentId, countryId, onSubmit } = props
  const dispatch = useDispatch()
  const [fields, setFields] = useState([initialFields])

  const [inputKeys, setInputKeys] = useState([Date.now()])
  let [countryUniversity, setCountryUniversity] = useState([])


  const MAX_FIELDS = 9

  const addFieldSet = () => {
    if (fields.length > MAX_FIELDS) {
      notification.warning({
        message: 'Cannot Add More Than 10 Records'
      })
      return
    }
    setFields([...fields, {
      universityId: undefined,
      courseName: '',
      campus: '',
      intake: '',
      fees: '',
      initialDeposit: '',
      scholarship: '',
      casDeposit: '',
      initialForInterview: ''
    }])
    setInputKeys([...inputKeys, Date.now()])
  }

  const events = {
    loadUniversity: async (item) => {
      let obj = {
        results: 1000000,
        universityCountry: countryId,
        sortField: 'universityName',
        sortOrder: 'ascend'
      }
      let data = await dispatch(listQuickSearchUniversities(obj))
      setCountryUniversity(data)
    }

  }
  useEffect(() => {
    events.loadUniversity()

  }, [])
  const handleSubmit = async () => {

    const requiredFields = [
      'universityId',
      'courseName',
      'campus',
      'intake',
      'fees',
      'initialDeposit',
      'scholarship',
      'casDeposit',
      'initialForInterview'
    ]

    const isValid = fields.every(field =>
      requiredFields.every(key => field[key] && field[key].toString().trim() !== '')
    )
    if (!isValid) {
      notification.error({ message: 'Please fill all required fields.' })
      return
    }

    const payload = {
      assessments: fields,
      assessmentId: assessmentId
    }

    const response = await dispatch(addAssessmentActivityFxn(payload))

    if (!response.error) {
      notification.success({ message: 'Assessment submitted successfully' })
      setFields(() => [{ ...initialFields }])
      onSubmit()
    } else {
      notification.error({ message: response.message || 'Submission failed' })
    }
  }
  const handleInputChange = (index, name, value) => {
    const updatedFields = [...fields]
    updatedFields[index][name] = value
    setFields(updatedFields)
  }
  const InterviewStatus = [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' }

  ]


  const deleteFieldSet = (index) => {
    setFields(fields.filter((_, idx) => idx !== index))
    setInputKeys(inputKeys.filter((_, idx) => idx !== index))
  }
  return (
    <Drawer
      visible={visible}
      onClose={onClose}
      width={'85%'}
      title={'Add Assessment'}
    >
      <div className='row'>
        <div className='col-lg-12'>
          <div className='card'>
            {fields.map((field, index) => (
              <div className={'bg-white  p-4'}
                   style={{ borderBottom: '1px solid #ddd' }}
                   key={index}>
                <Row gutter={24}>
                  <Col span={4}>
                    <InputBox
                      title='University'
                    >
                      <Select
                        name='universityId'
                        filterOption={filterOption}
                        placeholder='Select University'
                        allowClear
                        showSearch
                        value={field.universityId}
                        onChange={(e) => {
                          handleInputChange(index, 'universityId', e)
                        }}
                      >
                        {countryUniversity.map((item) => (
                          <Option key={item._id} value={item._id}>
                            {item.universityName}
                          </Option>
                        ))}
                      </Select>
                    </InputBox>


                  </Col>
                  <Col span={4}>
                    <InputBox title={'Course'}>
                      <Input
                        style={{ width: '100%' }}
                        value={field.courseName}
                        className={'form-control'}
                        name='courseName'
                        onChange={(e) => handleInputChange(index, e.target.name, e.target.value)}
                        placeholder='Enter Course'
                      />
                    </InputBox>

                  </Col>
                  <Col span={4}>
                    <InputBox title={'Campus'}>

                      <Input
                        style={{ width: '100%' }}
                        value={field.campus}
                        className={'form-control'}
                        name='campus'
                        onChange={(e) => handleInputChange(index, e.target.name, e.target.value)}
                        placeholder='Enter Campus'
                      />

                    </InputBox>

                  </Col>
                  <Col span={4}>
                    <InputBox title={'Intake'}>

                      <Input
                        style={{ width: '100%' }}
                        value={field.intake}
                        className={'form-control'}
                        name='intake'
                        onChange={(e) => handleInputChange(index, e.target.name, e.target.value)}
                        placeholder='Enter Intake'
                      />
                    </InputBox>

                  </Col>


                  <Col span={4}>
                    <InputBox title={'Fees'}>
                      <Input
                        style={{ width: '100%' }}
                        value={field.fees}
                        className={'form-control'}
                        name='fees'
                        onChange={(e) => handleInputChange(index, e.target.name, e.target.value)}
                        placeholder='Enter Fees'
                      />
                    </InputBox>
                  </Col>

                  <Col span={4}>
                    <InputBox title={'Initial Deposit'}>
                      <Input
                        style={{ width: '100%' }}
                        value={field.initialDeposit}
                        className={'form-control'}
                        name='initialDeposit'
                        onChange={(e) => handleInputChange(index, e.target.name, e.target.value)}
                        placeholder='Enter Initial Deposit'
                      />
                    </InputBox>
                  </Col>

                  <Col span={4}>
                    <InputBox title={'Scholarship'}>
                      <Input
                        style={{ width: '100%' }}
                        value={field.scholarship}
                        className={'form-control'}
                        name='scholarship'
                        onChange={(e) => handleInputChange(index, e.target.name, e.target.value)}

                        placeholder='Enter Scholarship'
                      />
                    </InputBox>
                  </Col>

                  <Col span={4}>
                    <InputBox title={'Interview'}>
                      <Input
                        style={{ width: '100%' }}
                        value={field.initialForInterview}
                        className={'form-control'}
                        name='initialForInterview'
                        onChange={(e) => handleInputChange(index, e.target.name, e.target.value)}
                        placeholder='Interview'
                      />
                    </InputBox>
                  </Col>
                  <Col span={4}>
                    <InputBox title={'CAS'}>
                      <Input
                        style={{ width: '100%' }}
                        value={field.casDeposit}
                        className={'form-control'}
                        name='casDeposit'
                        onChange={(e) => handleInputChange(index, e.target.name, e.target.value)}
                        placeholder='CAS'
                      />
                    </InputBox>
                  </Col>


                  <Col span={2}>
                    <Button className={'btn btn-danger mtop-5'} hidden={index === 0}
                            onClick={() => deleteFieldSet(index)}>
                      Delete
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <div className={'d-flex justify-content-between'}>
              <Button htmlType='submit'
                      className='btn btn-primary'
                      onClick={handleSubmit}
              >
                Submit
              </Button>
              <button className='btn btn-link' onClick={addFieldSet}>
                Add More
              </button>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  )
}

export default AddAssessment
